import { render, staticRenderFns } from "./AIQuestionnaire.vue?vue&type=template&id=28a0155e&scoped=true"
import script from "./AIQuestionnaire.vue?vue&type=script&lang=js"
export * from "./AIQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./AIQuestionnaire.vue?vue&type=style&index=0&id=28a0155e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0155e",
  null
  
)

export default component.exports